(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5378],{

/***/ 78539:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register/buyer",
      function () {
        return __webpack_require__(27781);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _meta_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53183);



var PageMetaHead = function(param) {
    var page_meta = param.page_meta, useExactTitle = param.useExactTitle;
    if (!page_meta) return null;
    var title = page_meta.title ? "".concat(_meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_NAME */ .iC, " - ").concat(page_meta.title) : _meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_NAME */ .iC;
    if (useExactTitle) {
        title = page_meta.title ? page_meta.title : _meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_NAME */ .iC;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            page_meta.keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: _meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_META_KEYWORDS */ .FK
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: title
            }, "og:site_name"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }, "twitter:title"),
            page_meta.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: page_meta.description
                    }, "description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: page_meta.description
                    }, "og:description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: page_meta.description
                    }, "twitter:description")
                ]
            }),
            page_meta.thumbnail && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: page_meta.thumbnail
                    }, "og:image"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:secure_url",
                        content: page_meta.thumbnail
                    }, "og:image:secure_url"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: page_meta.thumbnail
                    }, "twitter:image")
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageMetaHead);


/***/ }),

/***/ 27781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36123);
/* harmony import */ var src_site_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29951);
/* harmony import */ var src_logic_config_meta_PageMetaHead__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51199);





var Page = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .RegisterForm */ .B2f, {
        isBuyer: true,
        emailInvitation: props.email_invitation,
        companyIdInvitation: props.company_id_invitation,
        companyNameInvitation: props.company_name_invitation,
        companyCountryInvitation: props.company_country_invitation,
        companyStateInvitation: props.company_state_invitation,
        companyCityInvitation: props.company_city_invitation,
        companyIndustryInvitation: props.company_industry_invitation,
        companyAddressInvitation: props.company_address_invitation,
        companyFaxInvitation: props.company_fax_invitation,
        companyTrnInvitation: props.company_trn_invitation,
        companyWorkNumberInvitation: props.company_work_number_invitation,
        invitationId: props.invitation_id
    });
};
Page.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_1__/* .RegistrationLayout */ .UIm, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_logic_config_meta_PageMetaHead__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                page_meta: {
                    title: "Register as a Buyer | Access Verified Suppliers on eProcurement",
                    description: "Register as a buyer and gain instant access to verified vendors, AI-driven tendering tools, and intelligent sourcing features all on one secure SaaS platform."
                },
                useExactTitle: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .ImageOnTheRightLayout */ .Qat, {
                breadcrumbsAlias: src_site_map__WEBPACK_IMPORTED_MODULE_2__.sm.register.asBuyer.index.url,
                desktopImage: {
                    src: "/assets/images/sign-up/RegisterPhoto.png",
                    alt: ""
                },
                children: page
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(78539); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);